import { InfoIcon, Tooltip } from "@au-schein-de/au-ui-library";

type ProductDetailsTitleProps = {
	title: string;
	info: string;
};

export function ProductDetailsTitle({ title, info }: ProductDetailsTitleProps) {
	return (
		<h2 className="flex gap-1 items-center">
			<span className="text-body-bold text-gray-700">{title}</span>
			<Tooltip.Provider>
				<Tooltip.Root>
					<Tooltip.Trigger
						asChild
						onClick={(e) => {
							e.stopPropagation();
						}}
					>
						<span className="text-ansay-main">
							<InfoIcon size={6} />
						</span>
					</Tooltip.Trigger>
					<Tooltip.Content className="max-w-[260px] whitespace-normal break-words">
						{info}
					</Tooltip.Content>
				</Tooltip.Root>
			</Tooltip.Provider>
		</h2>
	);
}
